import Vue from 'vue'
import Router from 'vue-router'
import AppSideBar from './components/AppSidebar.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        landing: () => import('./views/Home.vue')
      }
    },
    {
      path: '/login',
      name: 'login',
      components: {
        login: () => import('./views/Login.vue')
      } 
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Dashboard.vue')
      } 
    },
    {
      path: '/signup',
      name: 'signUp',
      components: {
        content: () => import('./views/SignUp.vue')
      } 
    },
    {
      path: '/request-reset-password',
      name: 'requestResetPassword',
      components: {
        content: () => import('./views/RequestResetPassword.vue')
      } 
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      components: {
        content: () => import('./views/ResetPassword.vue')
      } 
    },
    {
      path: '/member-management/approvalbymember',
      name: 'memberApproval',
      components: {
        content: () => import('./views/MemberApproval.vue')
      } 
    },
    // Defaut page
    {
      path: '/customer-complaint-investigation-answer-submitted',
      name: 'customerComplaintInvestigationAnswerSubmitted',
      components: {
        content: () => import('./views/default/CustomerComplaintUserAnswered.vue')
      } 
    },
    // Dashboard page
    {
      path: '/ganttchart',
      name: 'ganttchart',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/dashboard/GanttChartView.vue')
      } 
    },
    {
      path: '/chart',
      name: 'chart',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Dashboard.vue')
      } 
    },
    {
      path: '/ccf-dasboard',
      name: 'ccfDashboard',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/dashboard/CcfDashboard.vue')
      } 
    },
    {
      path: '/ccf-dashboard/detail',
      name: 'ccfDashboardDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/dashboard/CcfDashboardDetail.vue')
      } 
    },
    {
      path: '/ncr-dasboard',
      name: 'ncrDashboard',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/dashboard/NcrDashboard.vue')
      } 
    },
    {
      path: '/ncr-dashboard/detail',
      name: 'ncrDashboardDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/dashboard/NcrDashboardDetail.vue')
      } 
    },
    {
      path: '/recall-dasboard',
      name: 'recallDashboard',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/dashboard/RecallDashboard.vue')
      } 
    },
    {
      path: '/recall-dashboard/detail',
      name: 'recallDashboardDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/dashboard/RecallDashboardDetail.vue')
      } 
    },
    // App Transaction Route
    {
      path: '/customer-complaint-sales',
      name: 'customerComplaintSales',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintSales.vue')
      } 
    },
    {
      path: '/customer-complaint-sales/detail',
      name: 'customerComplaintSalesDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintSalesDetail.vue')
      } 
    },
    {
      path: '/customer-complaint-investigation',
      name: 'customerComplaintInvestigation',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintInvestigation.vue')
      } 
    },
    {
      path: '/customer-complaint-investigation/detail',
      name: 'customerComplaintInvestigationDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintInvestigationDetail.vue')
        } 
    },
    {
      path: '/customer-complaint-choose-owner',
      name: 'customerComplaintChooseOwner',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintChooseOwner.vue')
        } 
    },
    {
      path: '/customer-complaint-investigation-answer',
      name: 'customerComplaintInvestigation',
      components: {
        content: () => import('./views/transaction/CustomerComplaintUserDetail.vue')
      } 
    },
    {
      path: '/customer-complaint-corrective',
      name: 'customerComplaintAreaOwner',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintAreaOwner.vue')
      } 
    },
    {
      path: '/customer-complaint-corrective/detail',
      name: 'customerComplaintAreaOwnerDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintAreaOwnerDetail.vue')
      } 
    },
    {
      path: '/customer-complaint-verification',
      name: 'customerComplaintVerification',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintVerification.vue')
      } 
    },
    {
      path: '/customer-complaint-approval',
      name: 'customerComplaintApproval',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintApproval.vue')
      } 
    },
    {
      path: '/customer-complaint-approval-declined',
      name: 'customerComplaintApprovalDeclined',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintApprovalDeclined.vue')
      } 
    },
    {
      path: '/customer-complaint-corrective-answer',
      name: 'customerComplaintCorrectiveAnswer',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintCorrectiveDetail.vue')
      } 
    },
    {
      path: '/customer-complaint-quality',
      name: 'customerComplaintQuality',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintQuality.vue')
      } 
    },
    {
      path: '/customer-complaint-quality/detail',
      name: 'customerComplaintQualityDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerComplaintQualityDetail.vue')
      } 
    },
    {
      path: '/recall',
      name: 'recall',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/Recall.vue')
      } 
    },
    {
      path: '/recall/detail',
      name: 'recallDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/RecallDetail.vue')
      } 
    },
    {
      path: '/recall-approval',
      name: 'recallApproval',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/RecallApproval.vue')
      } 
    },
    {
      path: '/ncr-user',
      name: 'ncrUser',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/NcrUser.vue')
      } 
    },
    {
      path: '/ncr-user/detail',
      name: 'ncrUserDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/NcrUserDetail.vue')
      } 
    },
    {
      path: '/ncr-investigation',
      name: 'ncrInvestigation',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/NcrInvestigation.vue')
      } 
    },
    {
      path: '/ncr-area-owner-cpar',
      name: 'ncrAreaOwnerCpar',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/NcrAreaOwnerCpar.vue')
      }
    },
    {
      path: '/ncr-area-owner-cpar-verify',
      name: 'ncrAreaOwnerCparVerify',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/NcrAreaOwnerCparVerify.vue')
      }
    },
    {
      path: '/ncr-corrective-answer',
      name: 'ncrCorrectiveAnswer',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/NcrCorrectiveDetail.vue')
      } 
    },
    {
      path: '/ncr-final-approval/detail',
      name: 'ncrQualityDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/NcrQualityDetail.vue')
      } 
    },
    // App Master Data Route
    {
      path: '/country',
      name: 'country',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Country.vue')
      } 
    },
    {
      path: '/country/detail',
      name: 'countryDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/CountryDetail.vue')
      } 
    },
    {
      path: '/enclosed',
      name: 'enclosed',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Enclosed.vue')
      } 
    },
    {
      path: '/enclosed/detail',
      name: 'enclosedDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/EnclosedDetail.vue')
      } 
    },
    {
      path: '/conformance-type',
      name: 'conformanceType',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/ConformanceType.vue')
      } 
    },
    {
      path: '/conformance-type/detail',
      name: 'conformanceTypeDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/ConformanceTypeDetail.vue')
      }
    },
    {
      path: '/complaint-media',
      name: 'complaintMedia',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/ComplaintMedia.vue')
      } 
    },
    {
      path: '/complaint-media/detail',
      name: 'complaintMediaDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/ComplaintMediaDetail.vue')
      } 
    },
    {
      path: '/customer-type',
      name: 'customerType',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/CustomerType.vue')
      } 
    },
    {
      path: '/customer-type/detail',
      name: 'customerTypeDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/CustomerTypeDetail.vue')
      } 
    },
    {
      path: '/customer',
      name: 'customer',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Customer.vue')
      } 
    },
    {
      path: '/customer/detail',
      name: 'customerDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/CustomerDetail.vue')
      } 
    },
    {
      path: '/model-of-delivery',
      name: 'modelOfDelivery',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/ModelOfDelivery.vue')
      } 
    },
    {
      path: '/model-of-delivery/detail',
      name: 'modelOfDeliveryDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/ModelOfDeliveryDetail.vue')
      }
    },
    {
      path: '/discharge-port',
      name: 'dischargePort',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/DischargePort.vue')
      } 
    },
    {
      path: '/discharge-port/detail',
      name: 'dischargePortDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/DischargePortDetail.vue')
      } 
    },
    {
      path: '/plant',
      name: 'plant',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Plant.vue')
      } 
    },
    {
      path: '/plant/detail',
      name: 'plantDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/PlantDetail.vue')
      } 
    },
    {
      path: '/product',
      name: 'product',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Product.vue')
      } 
    },
    {
      path: '/product/detail',
      name: 'productDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/ProductDetail.vue')
      } 
    },
    {
      path: '/packaging',
      name: 'packaging',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Packaging.vue')
      } 
    },
    {
      path: '/packaging/detail',
      name: 'packagingDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/PackagingDetail.vue')
      } 
    },
    {
      path: '/department',
      name: 'department',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Department.vue')
      } 
    },
    {
      path: '/department/detail',
      name: 'departmentDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/DepartmentDetail.vue')
      } 
    },
    {
      path: '/division',
      name: 'division',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Division.vue')
      } 
    },
    {
      path: '/division/detail',
      name: 'divisionDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/DivisionDetail.vue')
      } 
    },
    {
      path: '/mail-management',
      name: 'mailManagement',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MailManagement.vue')
      } 
    },
    {
      path: '/mail-management/detail',
      name: 'mailManagementDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MailManagementDetail.vue')
      } 
    },
    {
      path: '/member-management',
      name: 'memberManagement',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MemberManagement.vue')
      } 
    },
    {
      path: '/member-management/detail',
      name: 'memberManagementDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MemberManagementDetail.vue')
      } 
    },
    {
      path: '/user-profile',
      name: 'userProfile',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/UserProfile.vue')
      } 
    },
    // Report Path
    {
      path: '/print/cpar-cc',
      name: 'cpar-cc',
      components: {
        content: () => import('./views/report/CPARCC.vue')
      } 
    },
    {
      path: '/print/ccf',
      name: 'ccf',
      components: {
        content: () => import('./views/report/CCF.vue')
      } 
    },
    {
      path: '/print/ccf-email-uploader',
      name: 'ccf',
      components: {
        content: () => import('./views/report/CCFEmailUploader.vue')
      } 
    },
    {
      path: '/print/recall-report',
      name: 'recall-report',
      components: {
        content: () => import('./views/report/Recall.vue')
      } 
    },
    {
      path: '/print/cpar-ncr',
      name: 'cpar-ncr',
      components: {
        content: () => import('./views/report/CPARNcr.vue')
      } 
    },
  ]
})
